import { motion } from "framer-motion";
import { fadeUp, viewportOnce, stagger } from "../../lib/motion";
import { PRO_AUDIENCES } from "../../lib/pro";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

const ProAudiences = () => (
    <section
        id="pro-capabilities"
        data-testid="pro-audiences-section"
        className="relative border-y border-pro-steel/30 bg-pro-blue/20 py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-pro-steel-light">
                    PROFESSIONAL AUDIENCES
                </p>
                <span className="h-px flex-1 bg-pro-steel/40" />
            </motion.div>

            <motion.h2
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                data-testid="pro-audiences-headline"
                className="mt-12 max-w-4xl font-display text-4xl font-semibold leading-[1.1] text-pro-platinum md:text-6xl"
            >
                Built for every discipline shaping the built environment
                <span className="text-accent">.</span>
            </motion.h2>

            <motion.div
                variants={stagger}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-16 grid gap-px border border-pro-steel/30 bg-pro-steel/30 sm:grid-cols-2 lg:grid-cols-3"
            >
                {PRO_AUDIENCES.map((a, i) => (
                    <motion.div
                        key={a.role}
                        variants={fadeUp}
                        data-testid={`pro-audience-${slug(a.role)}`}
                        className="flex flex-col bg-pro-navy p-7"
                    >
                        <span className="font-mono text-[13px] tracking-[0.22em] text-pro-steel-light">
                            {String(i + 1).padStart(2, "0")}
                        </span>
                        <h3 className="mt-5 font-display text-lg font-semibold text-pro-platinum">
                            {a.role}
                        </h3>
                        <p className="mt-3 flex-1 text-[15px] leading-relaxed text-pro-steel-light">
                            {a.value}
                        </p>
                    </motion.div>
                ))}
            </motion.div>
        </div>
    </section>
);

export default ProAudiences;
